import { injectGlobal } from 'styled-components';
import { rem } from 'polished';
import normalize from '../../utils/normalize';
import colors from './variables/colors';
import { fonts, fontsFace, fontSize } from './variables/fonts';
import icons from './variables/icons';
import mediaqueries from './variables/mediaqueries';
import { BlockquoteBackground } from '../../../assets/images';

const iphonePreventZoomStyles = `
  select, textarea, input[type="text"], input[type="password"],
  input[type="datetime"], input[type="datetime-local"],
  input[type="date"], input[type="month"], input[type="time"],
  input[type="week"], input[type="number"], input[type="email"],
  input[type="url"]{ font-size: 16px; }
`;

/* eslint-disable */
injectGlobal`
${normalize()}
${fontsFace}

  *, *::after, *::before {
    font-family: ${fonts.book};
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
  *:focus {
    outline: 0.0625rem dotted ${colors.gray};
  }
  html {
    font-size: 100%;
  }
  body {
    font-size: ${rem("16px")};
    line-height: ${rem("25px")};
    margin: 0;
    color: ${colors.dark};
  }
  p {
    font-size: ${rem("15px")};
    margin: 0 0 ${rem("8px")} 0;
    ${mediaqueries.greaterThan("mobile")`
      font-size: ${rem("16px")};
    `};
  }
  strong {
    font-family: ${fonts.bold};
  }
  a {
    color: ${colors.primary};
    text-decoration: none;
  }
  a, button {
    cursor: pointer;
  }
  table {
    font-size: ${rem("16px")};
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${colors.dark};
    font-family: ${fonts.bold};
    font-weight: normal;
    margin: 0 0 ${rem("8px")} 0;
  }
  h1 {
    color: ${colors.dark};
    font-size: ${rem("23px")};
    line-height: ${rem("21px")};
    text-transform: uppercase;
    ${mediaqueries.lessThan("mobile")`
      font-size: ${rem("21px")};
    `};
    ${mediaqueries.greaterThan("desktop")`
      font-size: ${rem("28px")};
      line-height: ${rem("29px")};
    `};
  }
  h2 {
    color: ${colors.grayDarkest};
    font-size: ${rem("18px")};
    line-height: ${rem("20px")};
    margin-bottom:${rem("17px")};
    ${mediaqueries.lessThan("mobile")`
      margin-bottom: ${rem("17px")};
    `};
    ${mediaqueries.greaterThan("desktop")`
      font-size: ${rem("20px")};
    `};
  }
  h3 {
    font-size: ${rem("18px")};
    line-height: ${rem("24px")};
    margin-bottom:0;
    margin-top:${rem("17px")};
    text-transform: uppercase;
    ${mediaqueries.lessThan("mobile")`
      font-size: ${rem("16px")};
    `};
    ${mediaqueries.greaterThan("desktop")`
      font-size: ${rem("20px")};
      margin-bottom:${rem("8px")};
    `};
  }

  /* h5, h6  NO indicado en diseño para artítulos */

  h4 {
    font-size: ${rem("20px")};
    line-height: ${rem("22px")};
  }

  h5 {
    font-size: ${rem("18px")};
    line-height: ${rem("20px")};
  }
  h6 {
    font-size: ${rem("16px")};
    line-height: ${rem("18px")};
  }

  /** listas **/
  ul, ol {
    list-style-type: none;
    padding: 0;
    padding-left: ${rem("15px")};
  }

  ul, ol, dl {
    font-size: ${rem("16px")};
  }
  
  ul {
    margin: ${rem("4px")} 0 ${rem("9px")} 0;
    ${mediaqueries.lessThan("mobile")`
      padding-left: ${rem("15px")};
    `};
  }

  li {
    position: relative;
    margin-left: 0;
    padding-left: ${rem("28px")};
    &:before {
      position: absolute;
    }
  }

  ol {
    margin: 0;
    > li {
      counter-increment: step-counter;
      &:before {
        color: ${colors.primary};
        content: counter(step-counter) '. ';
        left: 0;
        font-family: ${fonts.bold};
        font-size: ${rem("18px")}; 
        top: ${rem("-1px")};
      }
    }
  }

  ul {
    > li {
      &:before {
        background-color: ${colors.primary};
        content: '';
        height: ${rem("5px")};
        top: ${rem("10px")};
        left: 0;
        width: ${rem("8px")};
      }
    }
  }

  ul ul, ol ul {
    padding-left: 0;
  }

  dd {
    margin-left: 0;
    padding: 0;
  }

  dt {
    font-family: ${fonts.medium};
    font-size: ${rem("18px")};
    margin-bottom: ${rem("15px")}; 
  }

  input, textarea {
    border: 1px solid ${colors.grayLight};
    caret-color: ${colors.secondary};
    font-size: ${fontSize.small};
    &::placeholder {
      font-family: ${fonts.bookItalic};
    }
  }

  blockquote{
    background: ${colors.grayLightest} url(${BlockquoteBackground}) no-repeat ${rem("23px")} ${rem("16px")};
    padding: ${rem("22px")} ${rem("18px")} ${rem("22px")} ${rem("88px")};  
    margin: 0 0 ${rem("15px")} 0;
    font-family: ${fonts.book};
    font-size: ${rem("18px")};

  }
  /* margin */
  .m-0{
    margin: 0;
  }
  .mt-5{ 
    margin-top: ${rem('5px')}
  }
  .mt-10{ 
    margin-top: ${rem('10px')}
  }
  .mt-15{ 
    margin-top: ${rem('15px')}
  }
  .mt-20{ 
    margin-top: ${rem('20px')}
  }
  .mt-30{ 
    margin-top: ${rem('30px')}
  }
  .mr-5{ 
    margin-right: ${rem('5px')}
  }
  .mr-10{ 
    margin-right: ${rem('10px')}
  }
  .mr-15{ 
    margin-right: ${rem('15px')}
  }
  .mr-20{ 
    margin-right: ${rem('20px')}
  }
  .mr-30{ 
    margin-right: ${rem('30px')}
  }
  .mb-5{ 
    margin-bottom: ${rem('5px')}
  }
  .mb-10{ 
    margin-bottom: ${rem('10px')}
  }
  .mb-15{ 
    margin-bottom: ${rem('15px')}
  }
  .mb-20{ 
    margin-bottom: ${rem('20px')}
  }
  .mb-30{ 
    margin-bottom: ${rem('30px')}
  }
  .ml-5{ 
    margin-left: ${rem('5px')}
  }
  .ml-10{ 
    margin-left: ${rem('10px')}
  }
  .ml-15{ 
    margin-left: ${rem('15px')}
  }
  .ml-20{ 
    margin-left: ${rem('20px')}
  }
  .ml-30{ 
    margin-left: ${rem('30px')}
  }
  /* font size */
  .fs-14{
    font-size: ${rem('14px')}
  }
  .fs-16{
    font-size: ${rem('16px')}
  }
  .fs-18{
    font-size: ${rem('18px')}
  }
  .pb-20{
    padding-bottom: ${rem('20px')};
  }
  .cursor-help{
    cursor: help;
  }
  .full-width{
    width: 100%;
  }
  .center{
    text-align: center;
  }
  .fl{
    float: left;
  }
  .fr{
    float: right;
  }
  .form-success{
    color: ${colors.success}
  }
  .form-error{
    color: ${colors.error}
  }
  /* WYSIWYG */
  /* New video embebed */
  .ql-video{
    width: 100%;
    height: auto;
    min-height: ${rem('370px')};
  }
  /* font size */
  .ql-size-small{
    font-size: ${rem('12px')};
  }
  .ql-size-large{
    font-size: ${rem('22px')};
  }
  .ql-size-huge{
    font-size: ${rem('32px')};
  }
  /* align */
  .ql-align-left{
    text-align: left;
  }
  .ql-align-center{
    text-align: center;
  }
  .ql-align-right{
    text-align: right;
  }
  .ql-align-justify{
    text-align: justify;
  }
  /* Calendar */
  .MuiPickersBasePicker-container .MuiPickersToolbar-toolbar,.MuiPickersBasePicker-container .MuiPickerDTTabs-tabs,.MuiPickersCalendar-week .MuiPickersDay-daySelected{
    background-color:  ${colors.primary}
  }
  .MuiButtonBase-root.MuiButton-textPrimary{
    color: ${colors.primary}
  }
  .MuiButtonBase-root.MuiButton-textPrimary:hover{
    background-color: #fae0de
  }
  .MuiPickersBasePicker-container .PrivateTabIndicator-colorSecondary-312{
    background-color:  ${colors.graySad}
  }
  /* Clock */
  .MuiPickersClock-clock .MuiPickersClockPointer-pointer,.MuiPickersClock-clock .MuiPickersClock-pin{
    background-color:  ${colors.primary}
  }
  .MuiPickersClock-clock .MuiPickersClockPointer-thumb{
    border-color: ${colors.primary}
  }

  /*** iPhone and iOS Form Input Zoom Fixes ***/
  /* Fix Input Zoom on devices older than iPhone 5: */
  @media screen and (device-aspect-ratio: 2/3) {
      ${iphonePreventZoomStyles}
  }

  /* Fix Input Zoom on iPhone 5, 5C, 5S, iPod Touch 5g */
  @media screen and (device-aspect-ratio: 40/71) {
    ${iphonePreventZoomStyles}
  }

  /* Fix Input Zoom on iPhone 6, iPhone 6s, iPhone 7  */
  @media screen and (device-aspect-ratio: 375/667) {
    ${iphonePreventZoomStyles}
  }

  /* Fix Input Zoom on iPhone 6 Plus, iPhone 6s Plus, iPhone 7 Plus, iPhone 8, iPhone X, XS, XS Max  */
  @media screen and (device-aspect-ratio: 9/16) {
    ${iphonePreventZoomStyles}
  }
  /* Fix Input Zoom on Iphone 11 */
  @media only screen 
    and (device-width: 414px) 
    and (device-height: 896px) 
    and (-webkit-device-pixel-ratio: 2) { 
      ${iphonePreventZoomStyles} 
    }
  @media only screen 
    and (device-width: 375px) 
    and (device-height: 812px) 
    and (-webkit-device-pixel-ratio: 3) { 
      ${iphonePreventZoomStyles} 
  }
  @media only screen 
    and (device-width: 414px) 
    and (device-height: 896px) 
    and (-webkit-device-pixel-ratio: 3) { 
      ${iphonePreventZoomStyles} 
  }  
`;

const Theme = {
  colors,
  fontSize,
  fonts,
  fontsFace,
  icons,
  mediaqueries
};

export default Theme;
